<template>
  <div id="app">
    <v-app id="inspire">
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card v-model="show" color="#FFFF99">
          <v-card-title>
            <v-icon large left>mdi-excavator</v-icon>
            Obra - Parte Semanal - CARGA CRONOGRAMA
          </v-card-title>
          <v-card-text class="pt-2">
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <v-select v-model="select" :items="obras" item-text="nombre" item-value="codigo" label="Obras"
                  return-object single-line menu-props="auto" hide-details required dense></v-select>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <h6>Cliente: {{ select.cliente }}</h6>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <h6>Comitente: {{ select.comitente }}</h6>
              </v-col>
            </v-row>
          </v-card-text>
          <!-- <input type="file" id="archivoExcel" @change="subirExcel" /> -->
        </v-card>
        <v-card>
          <input type="file" id="archivoExcel" @change="subirExcel" />
          <!-- <v-data-table :headers="cabecera" :items="items"> </v-data-table> -->
          <v-data-table :headers="headers" :items="cronograma" locale="es-ar" class="elevation-1" :items-per-page="10"
            :footer-props="{
              itemsPerPageText: 'Tareas por página',
            }">
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Completar Tareas</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="850px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                      Agregar Tarea
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row dense>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field autofocus v-model="editedItem.tarea" label="Tarea"></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="3" md="3">
                            <v-text-field v-model="editedItem.fechainicio" label="Fecha Inicio"></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="3" md="3">
                            <v-text-field v-model="editedItem.fechafin" label="Fecha Fin"></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="3" md="3">
                            <v-text-field v-model="editedItem.dias" label="Dias"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close">
                        Cancelar
                      </v-btn>
                      <v-btn color="blue darken-1" text @click="save">
                        Guardar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="headline">Está seguro que desea borrar?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" color="purple" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon small color="red" @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-card>

        <v-card color="blue" dark tile>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click.stop="guardarcronograma">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-app>
  </div>
</template>

<script>
import moment from "moment";
import axios from "../../axios-auth";
import readXlsFile from "read-excel-file";
export default {
  data: (vm) => ({
    usuario: "",
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    numberRule: [
      (v) => v.length > 1 || "2 digitos",
      (v) => v <= 31 || "El valor debe ser menor a 31",
    ],
    select: "",
    obras: [],
    Codigo: "",
    Nombre: "",
    cronograma: [],
    items: [],
    itemtarea: "",
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: "Tarea", value: "tarea", sortable: false },
      { text: "Fecha Inicio", value: "fechainicio", sortable: false },
      { text: "Fecha Final", value: "fechafin", sortable: false },
      { text: "Días", value: "dias", sortable: false },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    cabecera: [
      { text: "Tarea", value: "tarea" },
      { text: "fecha inicio", value: "fechainicio" },
      { text: "fecha final", value: "fechafin" },
      { text: "dias", value: "dias" },
    ],
    editedIndex: -1,
    editedItem: {
      tarea: "",
      fechainicio: "",
      fechafinal: "",
      dias: "",
    },
    defaultItem: {
      tarea: "",
      fechainicio: "",
      fechafinal: "",
      dias: "",
    },
    tareas: [],
  }),
  watch: {
    select: function (val) {
      this.codigo = this.select.codigo;
      this.asignarvalor();
    },
    dialog(val) {
      val || this.close();
      console.log(this.valid);
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Tarea" : "Editar Tarea";
    },
    show: {
      get() {
        //this.mostrar = true;
        //this.resptrabajo = this.$store.state.nombre.toString().trim();
        this.cargarObras();
        // return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarListado();
          this.$refs.form.resetValidation();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    subirExcel() {
      // const schema = {
      //   "0": {
      //     prop: "tarea",
      //     type: String,
      //   },
      //   "1": {
      //     prop: "fechainicio",
      //     type: String,
      //   },
      //   "2": {
      //     prop: "fechafin",
      //     type: String,
      //   },
      // };
      const map = {
        tarea: "tarea",
        fechainicio: "fechainicio",
        fechafin: "fechafin",
        dias: "dias",
      };

      const input = document.getElementById("archivoExcel");
      readXlsFile(input.files[0], { map }).then(({ rows, errors }) => {
        //this.cronograma = rows;
        rows.forEach((element) => {
          this.cronograma.push(element);
        });
        //  console.log("ROW");
      });
    },

    asignarvalor() {
      console.log("PASO POR ACA");
      const codigoobra = this.select.codigo;
      let self = this;
      axios
        .get("/Obras/CargarTareasCronograma?", {
          params: {
            codigo: codigoobra,
          },
        })
        .then((response) => {
          //self.cronograma = response.data;
          response.data.forEach((element) => {
            self.cronograma.push(element);
          });
        })
        .catch((error) => {
          self.cronograma = [];
          console.log(error);
        });
    },
    cargarObras() {
      let self = this;
      axios
        .get("/Obras/GetObrasPA", {
          params: {
            estado: "P",
            filtro: "",
          },
        })
        .then((response) => {
          self.obras = response.data;
          self.responsable = self.$store.state.nombre.toString().trim();
        })
        .catch((error) => {
          self.obras = [];
        });
    },
    editItem(item) {
      this.editedIndex = this.cronograma.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.cronograma.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.cronograma.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.cronograma[this.editedIndex], this.editedItem);
      } else {
        this.cronograma.push(this.editedItem);
      }
      this.close();
    },

    vaciarListado() {
      this.cronograma = [];
      this.cronog = [];
    },

    guardarcronograma() {
      this.$swal({
        title: "Guardar Cronograma",
        text: "¿Desea guardar los datos?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.cronograma.forEach((element) => {
            if (element.tarea != "" && element.tarea != null) {
              const fill = (number, len) =>
                "0".repeat(len - number.toString().length) + number.toString();
              this.itemtarea = fill(Number(this.item) + 1, 3);
              this.tareas.push({
                tarea: element.tarea,
                fechainicio: element.fechainicio,
                fechafin: element.fechafin,
                dias: element.dias,
                item: this.itemtarea,
              });
            }
          });
          var cronog = {
            codigo: this.select.codigo,
            detalle: this.tareas,
          };

          let self = this;
          axios
            .post("/Obras/Guardarcronograma", cronog)
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarListado();
              self.showAlert({
                icon: "success",
                title: "Cronograma guardado con éxito",
                vm: self,
              });
              self.$emit("close");
            })
            .catch({});
        } else {
        }
      });
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
  },
};
</script>
